
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-weldshop");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/weldshop/index.js
// module id = 3rjN
// module chunks = 6